import { Center, Flex, Spinner, Text } from '@chakra-ui/react'

const LoadingOverlay = ({ isActive, text = 'Loading ...' }) => {
  if (!isActive) {
    return null
  }
  return (
    <Center position="fixed" top={0} left={0} background="#222" opacity={0.7} w="100%" h="100%" zIndex="2000">
      <Flex direction={'column'} gap={5}>
        <Spinner color="white" size="xl" zIndex="1001" />
        <Text color="white">{text}</Text>
      </Flex>
    </Center>
  )
}

export default LoadingOverlay
